import React,{ useState, useEffect } from 'react';

import {
    Button
} from 'antd';

import {
    QuestionOutlined
} from '@ant-design/icons';

const siteDomain = headerVars.siteDomain;

function ModemUpgradeInstructions( { handleOpenQuestionModal, handleOpenQuestionModalSync } ) {
    return (
        <div id="modem-setup-component" className="modem-setup-component modem-upgrade-component">
            <h4>Modem Upgrade Instructions</h4>
            <p>In support of network technology enhancements in your serving area, we are pleased to upgrade your modem. To learn more about the technical rationale for this upgrade, please visit <a href="https://emea.technetix.com/our-vision/docsis3-1/" target="_blank" >Upgrading the network to DOCSIS 3.1</a>.</p>
            <p>We recently sent you an email, providing detailed information about your Internet service and this new modem that you have received.</p>
            <p>Please select one of the following three options to swap your old modem with the new one delivered to you (remembering to reconnect your existing router to the new modem – but only after the new modem has fully synched with the network). </p>

            <div className='modem-swap-walkthrough-container '>
                <div className='modem-swap-walkthrough-item'>
                    <div className='modem-swap-walkthrough-item-desc'>
                        <div className='modem-swap-step-number'>1</div>
                        <p><b>Option #1</b> - You control the timing of the modem swap. </p>
                    </div>
                    <div className='modem-swap-step-description'>
                        <ol>
                            <li>Visit <a href="/modem-swap" target="_blank">start.ca/modem-swap</a></li>
                            <li>Enter your customer ID (found on every invoice) and the MAC address of your new modem 
                                <Button 
                                    id="modem-swap-question-button"
                                    type="primary"
                                    style={{ marginLeft:'0.5rem' }} 
                                    size='small'
                                    shape="circle"
                                    onClick={ handleOpenQuestionModal } 
                                    icon={ <QuestionOutlined /> }
                                />.
                            </li>
                            <li>Select "Complete modem swap now."</li>
                            <li>Connect your new modem (wait for full synch, then reconnect your router) 
                                <Button 
                                    id="modem-swap-question-button"
                                    type="primary"
                                    style={{ marginLeft:'0.5rem' }} 
                                    size='small'
                                    shape="circle"
                                    onClick={ handleOpenQuestionModalSync } 
                                    icon={ <QuestionOutlined /> }
                                />.
                            </li>
                        </ol>
                    </div>
                </div>

                <div className='modem-swap-walkthrough-item'>
                    <div className='modem-swap-walkthrough-item-desc'>
                        <div className='modem-swap-step-number'>2</div>
                        <p><b>Option #2</b> - Wait for us to automate the modem swap.</p>
                    </div>
                    <div className='modem-swap-step-description'>
                        <ul>
                            <li>Our systems will automatically configure the network for your new modem shortly after 6 AM EDT, on the date specified within the email that we recently sent to you (please contact us if you did not receive this email and you would prefer to proceed with this option). </li>
                            <li>Connect your new modem – either the night before, or the morning after the scheduled network configuration.</li>
                            <li>Note: If you wait until morning, your Internet connection will be offline until you connect the new modem.  Any important devices will also be offline (e.g., VoIP phone, remotely monitored security system, etc.).</li>
                        </ul>
                    </div>
                </div>

                <div className='modem-swap-walkthrough-item'>
                    <div className='modem-swap-walkthrough-item-desc'>
                        <div className='modem-swap-step-number'>3</div>
                        <p><b>Option #3</b> - Contact us for an assisted modem swap.</p>
                    </div>
                    <div className='modem-swap-step-description'>
                        <ul>
                            <li>Call <a href="tel:866-434-5888">866-434-5888</a> and select option #2 for Support.</li> 
                            <li>Request assistance connecting your new modem. </li>
                            <li>
                                Provide your customer ID (found on every invoice) and the MAC address on the modem 
                                <Button 
                                    id="modem-swap-question-button"
                                    type="primary"
                                    style={{ marginLeft:'0.5rem' }} 
                                    size='small'
                                    shape="circle"
                                    onClick={ handleOpenQuestionModal } 
                                    icon={ <QuestionOutlined /> }
                                />.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModemUpgradeInstructions